import React from 'react'
import {useField} from "formik"
import {useTranslation} from 'react-i18next'

export default ({name, title, children}) => {
  const {t} = useTranslation();
  const [field, meta] = useField(name);

  return (
    <div className={`formGroup${(meta.touched && meta.error) ? ' error' : ''}`}>
      <div className='formField'>
        <div className="fieldTitle" dangerouslySetInnerHTML={{__html: t(title)} /* i18next-extract-disable-line */} />
        {children}
        <div className='choice'>
          <label>
            <input {...field} type='radio' value='yes' checked={field.value === 'yes'} />
            {t('Accetto')}
          </label>
        </div>
        <div className='choice'>
          <label>
            <input {...field} type='radio' value='no' checked={field.value === 'no'} />
            {t('Non Accetto')}
          </label>
        </div>
      </div>
      {meta.touched && meta.error && <div className="errorMessage">{meta.error}</div>}
    </div>
  )
}